
import Promise from "plugins/bluebird/index"
import * as Sentry from "@sentry/browser"

import {
  get as get_current_authenticated_user,
  ResultTypeEnums as GetCurrentAuthenticatedUserTypes,
} from "app/resources/current_authenticated_user/get/index"

import { setContactInfoData } from "app/local_storages/contact_info_storage"

import auth_ee from "app/authentication/manager"

import {
  performance,
} from "plugins/user-timing-polyfill"

let last_contact_info_sync_promise = Promise.resolve()

const cacheContactInfoToLocal = () => {
  performance.mark("spacious_mark__cacheContactInfoToLocal__get_current_authenticated_user__start")

  return get_current_authenticated_user()
  .then(({result_type, data}) => {
    performance.mark("spacious_mark__cacheContactInfoToLocal__get_current_authenticated_user__end")
    performance.measure(
      "spacious_measure__cacheContactInfoToLocal__get_current_authenticated_user",
      "spacious_mark__cacheContactInfoToLocal__get_current_authenticated_user__start",
      "spacious_mark__cacheContactInfoToLocal__get_current_authenticated_user__end",
    )

    switch (result_type) {
      case GetCurrentAuthenticatedUserTypes.SUCCESS: {
        setContactInfoData({
          user_authentication_handle: data.authentication_handle,
          contact_name:               data.contact_name,
          contact_email_address:      data.contact_email_address,
          contact_phone_number:       data.contact_phone_number,
        })
        // Sneaking Sentry code in here to avoid duplicate requests
        Sentry.setUser({
          id:         data.authentication_handle,
          email:      data.contact_email_address,
          username:   data.contact_name,
        })
        break
      }
      case GetCurrentAuthenticatedUserTypes.NOT_SIGNED_IN: {
        setContactInfoData({
          user_authentication_handle: null,
        })
        break
      }
      default: {
        break
      }
    }

    if (result_type !== GetCurrentAuthenticatedUserTypes.SUCCESS) {
      return
    }

    setContactInfoData({
      user_authentication_handle: data.authentication_handle,
      contact_name:               data.contact_name,
      contact_email_address:      data.contact_email_address,
      contact_phone_number:       data.contact_phone_number,
    })
  })
}

const onLoad = () => {
  auth_ee.on("sign_up:success:action", () => {
    last_contact_info_sync_promise = cacheContactInfoToLocal()
    last_contact_info_sync_promise.done()
  })
  auth_ee.on("sign_in:success:action", () => {
    last_contact_info_sync_promise = cacheContactInfoToLocal()
    last_contact_info_sync_promise.done()
  })

  // Do this after TTI since not very urgent task
  window.spacious_post_tti_tasks = window.spacious_post_tti_tasks || []
  window.spacious_post_tti_tasks.push(() => {
    cacheContactInfoToLocal().done()
  })

  return Promise.resolve()
}

const getLastContactInfoSyncPromise = () => last_contact_info_sync_promise

export {
  onLoad,
  getLastContactInfoSyncPromise,
}
